import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { Response } from "../../types/global";
import {
  allWalletBalanceResponse,
  bonusSummaryResponse,
  payloadBonusTransaction,
  payloadBonusSummary,
  payloadConvertWallet,
  payloadHistory,
  payloadTransferWallet,
  payloadWalletBalance,
  payloadWithdrawWallet,
  transactionHistoryResponse,
  withdrawHistoryResponse,
  bonusTransactionHistoryResponse,
} from "../../types/wallet";

import {
  getWalletBalance as getWalletBalanceUrl,
  getAllWalletBalance as getAllWalletBalanceUrl,
  getBonusSummary as getBonusSummaryUrl,
  convertWallet as convertWalletUrl,
  getTransactionHistory as getTransactionHistoryUrl,
  getWithdrawalHistory as getWithdrawalHistoryUrl,
  withdrawalWallet as withdrawalWalletUrl,
  transferWallet as transferWalletUrl,
  getBonusTransactionHistory as getBonusTransactionHistoryUrl,
} from "../../helpers/apiUrl";
import { axiosClient } from "../../helpers/apiClient";

export const getWalletBalanceList = createAsyncThunk(
  "wallet/get-all-wallet",
  async (memberId: number) => {
    const urlWithMemberId = `${getAllWalletBalanceUrl}/?memberId=${memberId}`;
    return axiosClient
      .get(urlWithMemberId)
      .then((d: AxiosResponse<Response<allWalletBalanceResponse[]>>) => d.data)
      .then((d: Response<allWalletBalanceResponse[]>) => d.data);
  },
);

export const getBonusSummaryList = createAsyncThunk(
  "reward/report-reward-summary",
  async (payload: payloadBonusSummary) => {
    return axiosClient
      .post(getBonusSummaryUrl, payload)
      .then((d: AxiosResponse<Response<bonusSummaryResponse[]>>) => d.data)
      .then((response: Response<bonusSummaryResponse[]>) => response.data);
  },
);

export const getWalletBalance = createAsyncThunk(
  "wallet/get-balance",
  async (payload: payloadWalletBalance) => {
    return axiosClient
      .post(getWalletBalanceUrl, payload)
      .then((d: AxiosResponse) => d.data)
      .then((response: AxiosResponse) => response.data);
  },
);

export const getTransactionHistory = createAsyncThunk(
  "wallet/report-statement",
  async (payload: payloadHistory) => {
    return axiosClient
      .post(getTransactionHistoryUrl, payload)
      .then(
        (d: AxiosResponse<Response<transactionHistoryResponse[]>>) => d.data,
      )
      .then(
        (response: Response<transactionHistoryResponse[]>) => response.data,
      );
  },
);

export const getWithdrawHistory = createAsyncThunk(
  "wallet/report-withdraw",
  async (payload: payloadHistory) => {
    return axiosClient
      .post(getWithdrawalHistoryUrl, payload)
      .then((d: AxiosResponse<Response<withdrawHistoryResponse[]>>) => d.data)
      .then((response: Response<withdrawHistoryResponse[]>) => response.data);
  },
);

export const getBonusTransactionHistory = createAsyncThunk(
  "wallet/report-reward-statement",
  async (payload: payloadBonusTransaction) => {
    return axiosClient
      .post(getBonusTransactionHistoryUrl, payload)
      .then(
        (d: AxiosResponse<Response<bonusTransactionHistoryResponse[]>>) =>
          d.data,
      )
      .then(
        (response: Response<bonusTransactionHistoryResponse[]>) =>
          response.data,
      );
  },
);

export const covertWallet = createAsyncThunk(
  "wallet/add-convert",
  async (payload: payloadConvertWallet) => {
    return axiosClient
      .post(convertWalletUrl, payload)
      .then((d: AxiosResponse) => d)
      .then((response: AxiosResponse) => response);
  },
);

export const withdrawalWallet = createAsyncThunk(
  "wallet/add-withdraw",
  async (payload: payloadWithdrawWallet) => {
    return axiosClient
      .post(withdrawalWalletUrl, payload)
      .then((d: AxiosResponse) => d)
      .then((response: AxiosResponse) => response);
  },
);

export const transferWallet = createAsyncThunk(
  "wallet/add-transferWallet",
  async (payload: payloadTransferWallet) => {
    return axiosClient
      .post(transferWalletUrl, payload)
      .then((d: AxiosResponse) => d)
      .then((response: AxiosResponse) => response);
  },
);
